export default __webpack_public_path__ + "static/media/stay_eat.9b7c789c.svg";